// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qgIZ","right":"styles_right__2TfB6"};